<p-card *ngIf="scenario !== 'none' && !loadFailed" class="w-full" styleClass="h-full">
    <ng-template pTemplate="content">
        <div class="flex align-items-center justify-content-between mb-2">
            <span class="custom-bold text-slate-800"><i class="pi pi-sparkles mr-2"></i>Your Plan Story: Renewal edition</span>
        </div>

        <ng-container *ngIf="isLoading">
            <p-skeleton width="100%" height="1rem" styleClass="bg-slate-100 mb-2" />
            <p-skeleton width="80%" height="1rem" styleClass="bg-slate-100 mb-2" />
            <p-skeleton width="60%" height="1rem" styleClass="bg-slate-100" />
        </ng-container>

        <ng-container *ngIf="!isLoading && story">
            <p class="mt-0 mb-3 text-sm text-slate-700 md:text-base">{{ story.narrative }}</p>
            <div class="flex gap-4 flex-wrap">
                <div class="flex flex-column" *ngFor="let stat of story.stats">
                    <span class="font-bold text-lg text-slate-800">{{ stat.value }}</span>
                    <span class="text-xs text-slate-500">{{ stat.label }}</span>
                </div>
            </div>

            <div class="mt-3" *ngIf="alertCardContent as cta">
                <p-button [label]="cta.button.name" [rounded]="true" severity="warn" class="w-full"
                        styleClass="w-full md:max-w-19rem shadow-button"
                    (onClick)="onCtaClick()" data-auto-id="my-plan-story-cta-button" />
                <div class="mt-2" *ngIf="scenario === 'renewal'">
                    <p-tag value="Special 30% off renewal offer available now."
                        styleClass="font-bold bg-emerald-100 border-emerald-200 md:text-base p-component p-tag text-emerald-900 text-sm"></p-tag>
                </div>
            </div>
        </ng-container>
    </ng-template>
</p-card>
